var pluralization_en_GB = (choice) => choice === 1 ? 0 : 1;

var pluralization_es_ES = (choice) => choice === 1 ? 0 : 1;

var pluralization_ru_RU = (choice, choicesLength) => {
    /** @example удалить рассылку | удалить рассылки */
    if (choicesLength === 2) {
        return choice === 1 ? 0 : 1;
    }
    /** @example 1 яблоко|2-4 яблока, x2-x4 яблока|0 яблок, x0 яблок, 5-9 яблок, 11-14 яблок */
    const mod100 = choice % 100;
    return mod100 % 10 === 1 && mod100 !== 11
        ? 0
        : (mod100 % 10 >= 2 &&
            mod100 % 10 <= 4 &&
            !(mod100 >= 10 && mod100 < 15)
            ? 1
            : 2);
};

const get = (messages, path) => {
    let i = 0;
    let slice = messages[path[0]];
    while (i < path.length) {
        if (typeof slice === 'string' && i + 1 === path.length) {
            return slice;
        }
        if (typeof slice !== 'object') {
            return undefined;
        }
        slice = slice[path[++i]];
    }
    return slice;
};
const replace = (message, values) => {
    return Object.keys(values).reduce((message, key) => {
        const pattern = new RegExp(`\\\{${key}\\\}`, 'g');
        const replacement = String(values[key]);
        return message.replace(pattern, replacement);
    }, message);
};
const compile = (messages, path, values = undefined) => {
    const message = get(messages, path);
    if (typeof message === 'string' && values) {
        return replace(message, values);
    }
    return message;
};
const fail = (message) => {
    throw new Error(message);
};
const t = (locale, messages, path, values = undefined) => {
    var _a;
    const keys = path.split('.');
    if (locale) {
        const message = compile((_a = messages[locale]) !== null && _a !== void 0 ? _a : {}, keys, values);
        return typeof message !== 'object'
            ? message
            : fail(`Translation for "${locale}:${path}" is not translatable`);
    }
    return undefined;
};
/**
 * @param {string} template Варианты множественных форм, разделенные знаком "|"
 * @param {number} choice Количество, по которому выбираем форму
 * @param {PluralizationRule} rule
 * @return {string} Выбранная форма
 */
const plural = (template, choice, rule) => {
    const forms = template.split('|');
    return forms[rule(choice, forms.length)];
};
class I18n {
    constructor(options = undefined, parent = undefined) {
        var _a, _b, _c;
        this.parent = parent;
        this.messages = (_a = options === null || options === void 0 ? void 0 : options.messages) !== null && _a !== void 0 ? _a : {};
        this.computed = (_b = options === null || options === void 0 ? void 0 : options.computed) !== null && _b !== void 0 ? _b : {};
        this.pluralization = Object.assign({ 'en-GB': pluralization_en_GB, 'es-ES': pluralization_es_ES, 'ru-RU': pluralization_ru_RU }, ((_c = options === null || options === void 0 ? void 0 : options.pluralization) !== null && _c !== void 0 ? _c : {}));
        this.fallback = options === null || options === void 0 ? void 0 : options.fallback;
    }
    t(locale, path, values = undefined) {
        var _a, _b;
        try {
            const _t = (locale) => t(locale, this.messages, path, values);
            return (_b = (_a = _t(locale)) !== null && _a !== void 0 ? _a : _t(this.fallback)) !== null && _b !== void 0 ? _b : fail(`Translation for "${path}" does not exists`);
        }
        catch (e) {
            if (this.parent) {
                return this.parent.t(locale, path, values);
            }
            throw e;
        }
    }
    tc(locale, path, choice, values = undefined) {
        return plural(this.t(locale, path, values), choice, this.pluralization[locale]);
    }
    compute(locale, key, values) {
        const computed = this.computed[key];
        if (computed) {
            return computed(localize(this, locale), values);
        }
        if (this.parent) {
            return this.parent.compute(locale, key, values);
        }
        return fail('Key ' + key + ' is not registered');
    }
    extend(options) {
        return new I18n(Object.assign({ pluralization: this.pluralization, fallback: this.fallback }, options), this);
    }
}
const localize = (i18n, locale) => ({
    t(path, values = undefined) {
        return i18n.t(locale, path, values);
    },
    tc(path, choice, values = undefined) {
        return i18n.tc(locale, path, choice, values);
    },
    compute(key, values) {
        return i18n.compute(locale, key, values);
    },
});

export { I18n, localize };
